import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { paymentsApi, subscribe } from '../utils/paymentsStore';
import { PageHeader, Panel, Icon, useToast } from '../components/ui';
import { NOTES_APP_URL } from '../components/Sidebar';

export default function SettingsPage() {
  const [stats, setStats] = useState({ claims: 0, payers: 0, imports: 0 });
  const [imports, setImports] = useState([]);
  const [confirm, setConfirm] = useState('');
  const [showToast, toastNode] = useToast();

  useEffect(() => {
    const load = () => {
      paymentsApi.stats().then(setStats).catch(() => {});
      paymentsApi.listImports().then(setImports).catch(() => setImports([]));
    };
    load(); return subscribe(load);
  }, []);

  const run = async (label, fn) => { try { await fn(); showToast(label); } catch (e) { showToast(e.message || 'Failed', 'error'); } setConfirm(''); };

  return (
    <main className="main-content ops-main">
      <div className="ops-page">
        <PageHeader title="Settings" subtitle="Platform configuration and reference data." />
        <div className="ops-grid-2">
          <Panel title="Reference data">
            <ul className="ops-list">
              <li><div className="ops-list__main"><Link to="/payments/payers" className="ops-cell-main">Payers</Link><div className="ops-cell-sub">Insurance companies, short names and import aliases</div></div><span className="ops-cell-sub">{stats.payers} payers</span></li>
              <li><div className="ops-list__main"><Link to="/users" className="ops-cell-main">Users</Link><div className="ops-cell-sub">Caregivers and administrators (Cognito)</div></div><Icon name="chevron" /></li>
              <li><div className="ops-list__main"><Link to="/users" className="ops-cell-main">SMS reminders</Link><div className="ops-cell-sub">Configured per caregiver from the SMS button on the Users page</div></div><Icon name="chevron" /></li>
              <li><div className="ops-list__main"><a href={NOTES_APP_URL} target="_blank" rel="noreferrer" className="ops-cell-main">Progress Notes app</a><div className="ops-cell-sub">Progress notes, AI Live-in Caregiver Notes and AI EVV T&amp;A Agent live there</div></div><Icon name="external" /></li>
            </ul>
          </Panel>
          <Panel title="Payments data">
            <p className="ops-help">Claims, payers and import history are stored centrally, so every administrator works from the same payment log. Roll back an import here if the numbers look wrong.</p>
            <div className="ops-stat-row"><div className="ops-stat"><b>{stats.claims}</b><span>Claims stored</span></div><div className="ops-stat"><b>{stats.imports}</b><span>Import batches</span></div></div>
            <div className="ops-actions" style={{ flexWrap: 'wrap' }}>
              <Link to="/payments/import" className="ops-btn ops-btn--primary">Import a workbook</Link>
              {confirm === 'clear' ? <span className="ops-actions"><button type="button" className="ops-btn ops-btn--danger ops-btn--sm" onClick={() => run('All claims removed', () => paymentsApi.clearClaims())}>Yes, delete all claims for everyone</button><button type="button" className="ops-btn ops-btn--sm" onClick={() => setConfirm('')}>Cancel</button></span>
                : <button type="button" className="ops-btn ops-btn--ghost" onClick={() => setConfirm('clear')}><Icon name="trash" /> Clear claims</button>}
            </div>
            {imports.length > 0 && (
              <>
                <h3 style={{ margin: '18px 0 8px', fontSize: 14 }}>Import history</h3>
                <ul className="ops-list">
                  {imports.map(i => (
                    <li key={i.batchId}>
                      <div className="ops-list__main"><span className="ops-cell-main">{i.fileName || i.batchId}</span><div className="ops-cell-sub">{new Date(i.at).toLocaleString()}{i.by ? ` by ${i.by}` : ''} · {i.inserted} new, {i.updated} updated, {i.skipped} skipped</div></div>
                      {confirm === i.batchId ? <span className="ops-actions"><button type="button" className="ops-btn ops-btn--danger ops-btn--sm" onClick={() => run('Import rolled back', () => paymentsApi.rollbackImport(i.batchId))}>Confirm</button><button type="button" className="ops-btn ops-btn--sm" onClick={() => setConfirm('')}>Cancel</button></span>
                        : <button type="button" className="ops-btn ops-btn--sm" onClick={() => setConfirm(i.batchId)}>Roll back</button>}
                    </li>
                  ))}
                </ul>
              </>
            )}
          </Panel>
        </div>
      </div>
      {toastNode}
    </main>
  );
}
